function routerConfig($stateProvider, $urlRouterProvider) {
  'ngInject';
  $stateProvider
    .state('app', {
      url: '/',
      templateUrl: 'app/app.html',
      controller: 'AppController',
      controllerAs: 'app',
      resolve: {
        currentUser: function (User) {
          'ngInject';
          return User.getUser();
        }
      },
      data: {
        login: {
          open: false,
          view: 'login'
        }
      }
    }
  );
  $urlRouterProvider.otherwise('/');
}

export default routerConfig;



/** WEBPACK FOOTER **
 ** ./src/app/app.route.js
 **/